import React, { createContext, useContext, useState, useEffect } from 'react';
import {useNavigate} from "react-router-dom";

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const navigate = useNavigate();

    const checkAuthStatus = () => {
        const jwt = JSON.parse(localStorage.getItem("userInfo") || "{}");
        const currentPath = window.location.pathname;
        if (!jwt.expires) {
            setIsAuthenticated(false);
            localStorage.removeItem("userInfo");
            if (currentPath.includes("admin") || currentPath.includes("curbside")) {
                navigate("/");
            }
            return;
        }

        if (new Date(jwt.expires) < new Date()) {
            setIsAuthenticated(false);
            localStorage.removeItem("userInfo");
            if (currentPath.includes("admin") || currentPath.includes("curbside")) {
                navigate("/");
            }
        } else {
            setIsAuthenticated(true);
        }
    };

    useEffect(() => {
        checkAuthStatus();
        const interval = setInterval(checkAuthStatus, 60000);
        return () => clearInterval(interval);
    }, []);

    return (
        <AuthContext.Provider value={{ isAuthenticated, checkAuthStatus }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
